/**
 * Gets the feature footer options.
 *
 * @param translate The translate handler.
 */
export function getFeatureOptions(translate) {
  return [
    {
      name: translate("footer.feature_link_group.link_editor"),
      as: "router-link",
      attributes: {
        to: { name: "features.custom-links" },
      },
    },
    {
      name: translate("footer.feature_link_group.link_management"),
      as: "router-link",
      attributes: {
        to: { name: "features.link-management" },
      },
    },
    {
      name: translate("footer.feature_link_group.branded_links"),
      as: "router-link",
      attributes: {
        to: { name: "features.branded-links" },
      },
    },
    {
      name: translate("footer.feature_link_group.short_url_tracking"),
      as: "router-link",
      attributes: {
        to: { name: "features.link-analytics" },
      },
    },
    {
      name: translate("footer.feature_link_group.qr_code"),
      as: "router-link",
      attributes: {
        to: { name: "features.qr-code-generator" },
      },
    },
    {
      name: translate("footer.feature_link_group.short_url_api"),
      as: "router-link",
      attributes: {
        to: { name: "features.short-url-api" },
      },
    },
  ];
}

/**
 * Gets the resource footer options.
 *
 * @param translate The translate handler.
 */
export function getResourceOptions(translate) {
  return [
    {
      name: translate("footer.resources_link_group.blog"),
      as: "router-link",
      attributes: {
        to: { name: "blog" },
      },
    },
    {
      name: translate("footer.resources_link_group.for_developers"),
      as: "router-link",
      attributes: {
        to: { name: "resources.dev" },
      },
    },
    {
      name: translate("footer.resources_link_group.our_proven_process"),
      as: "router-link",
      attributes: {
        to: { name: "resources.our-proven-process" },
      },
    },
    {
      name: translate("footer.resources_link_group.about_us"),
      as: "router-link",
      attributes: {
        to: { name: "resources.about-us" },
      },
    },
  ];
}

/**
 * Gets the "contact us" footer options.
 *
 * @param translate The translate handler.
 */
export function getContactOptions(translate) {
  return [
    {
      name: translate("footer.contact_link_group.help_desk"),
      as: "router-link",
      attributes: {
        to: { name: "helpdesk" },
      },
    },
    {
      name: translate("footer.contact_link_group.contact_sales"),
      as: "router-link",
      attributes: {
        to: { name: "contact-sales" },
      },
    },
    {
      name: translate("footer.contact_link_group.contact_support"),
      as: "router-link",
      attributes: {
        to: { name: "freescout" },
      },
    },
    {
      name: translate("footer.contact_link_group.report_abuse"),
      as: "router-link",
      attributes: {
        to: { name: "freescout" },
      },
    },
  ];
}

export function getLegalOptions(translate) {
  return [
    {
      name: translate("footer.legal_link_group.terms_conditions"),
      as: "router-link",
      attributes: {
        to: { name: "terms" },
      },
    },
    {
      name: translate("footer.legal_link_group.privacy_policy"),
      as: "router-link",
      attributes: {
        to: { name: "privacy" },
      },
    },
    {
      name: translate("footer.legal_link_group.cookie_policy"),
      as: "router-link",
      attributes: {
        to: { name: "cookies" },
      },
    },
    {
      name: translate("footer.legal_link_group.accessibility_statement"),
      as: "router-link",
      attributes: {
        to: { name: "accessibility" },
      },
    },
    {
      name: translate("footer.legal_link_group.privacy_manager"),
      as: "router-link",
      attributes: {
        to: { name: "privacy-manager" },
      },
    },
  ];
}
